/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vtp_Shipments_Search_LabelInputs */

const vi_vtp_shipments_search_label = /** @type {(inputs: Vtp_Shipments_Search_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm`)
};

/**

* @param {Vtp_Shipments_Search_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vtp_shipments_search_label = /** @type {((inputs?: Vtp_Shipments_Search_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vtp_Shipments_Search_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vtp_shipments_search_label(inputs)
});